import { useEffect, useState } from 'react';
import { Typography, Box, Link, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import './modalStyles.css';

const ModalPrevention = () => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(JSON.parse(localStorage.getItem('modalPrevention') || 'false'));
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (!open) {
      localStorage.setItem('modalPrevention', JSON.stringify(true));
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, []);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className="modalBackground">
          <div className="modalContainerPrevention">
            <Box color="#42526EDB" display="flex" justifyContent="end">
              <IconButton onClick={handleClose}>
                <CloseOutlinedIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box sx={{ px: mobileDevice ? 1 : 2 }}>
              <Box sx={{ mt: mobileDevice ? 2 : 2 }}>
                <Typography sx={{ textAlign: mobileDevice ? 'center' : 'start' }}>
                  Recuerda que en <span className="green">Iban Online</span> no solicitamos dinero
                  para la autorización y otorgamiento de créditos, los trámites son totalmente
                  gratuitos.
                </Typography>
              </Box>
              <Box sx={{ mt: mobileDevice ? 2 : 2 }}>
                <Typography sx={{ textAlign: mobileDevice ? 'center' : 'start' }}>
                  Ningún ejecutivo deberá cobrar alguna cantidad antes del otorgamiento del crédito.
                </Typography>
              </Box>
              <Box sx={{ mt: mobileDevice ? 2 : 2 }}>
                <Typography sx={{ textAlign: mobileDevice ? 'center' : 'start' }}>
                  Consulta detalles de nuestros productos, así como requisitos de contratación,
                  ingresando a nuestro sitio oficial en{' '}
                  <a
                    target={'_blank'}
                    style={{ color: '#00A153', textDecoration: 'none' }}
                    href="https://www.ibanonline.com.mx"
                    rel="noreferrer"
                  >
                    www.ibanonline.com.mx
                  </a>{' '}
                  y/o comunícate a nuestro Centro de atención al cliente{' '}
                  <a
                    target={'_blank'}
                    style={{ color: '#00A153', textDecoration: 'none' }}
                    href="cel:+525544459254"
                    rel="noreferrer"
                  >
                    5544459254
                  </a>{' '}
                  y/o por correo a{' '}
                  <a
                    target={'_blank'}
                    style={{ color: '#00A153', textDecoration: 'none' }}
                    href="mailto:hola@ibanonline.com.mx"
                    rel="noreferrer"
                  >
                    hola@ibanonline.com.mx
                  </a>
                </Typography>
              </Box>
            </Box>
            <Box display="flex" justifyContent="center" sx={{ mt: mobileDevice ? 3 : 5.5 }}>
              <Button variant="contained" size="large" onClick={handleClose}>
                ¡De acuerdo!
              </Button>
            </Box>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalPrevention;
